import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

import type { PhotoThumbnailProps } from './types'

const getContainerWidth = (size: NonNullable<PhotoThumbnailProps['size']>): number => {
  const widths: Record<NonNullable<PhotoThumbnailProps['size']>, number> = {
    tiny: 33,
    small: 42,
    medium: 48,
    large: 60,
    extraLarge: 66,
  }

  return widths[size]
}

export const Container = styled.div<{ $size: NonNullable<PhotoThumbnailProps['size']> }>`
  width: ${({ $size }) => `${getContainerWidth($size)}px`};

  flex-shrink: 0;
`

export const Image = styled.img`
  width: 100%;
  height: 100%;
  background-color: ${Colors.GS200};
  object-fit: contain;

  border-radius: var(--radius-brand);
  border: 1px solid var(--border-transparent);
`

export const Placeholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${Colors.GS200};
  color: ${Colors.GS400};

  border-radius: var(--radius-brand);
  border: 1px solid var(--border-transparent);
`
